import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { PropertyType } from '../models/declarations';
import { PropertyDetailsModel } from '../models/propertyDetailsModel';
import { PropertyFinancialsModel } from '../models/propertyFinancialsModel';

@Component({
  selector: 'app-propertydetails',
  templateUrl: './propertydetails.component.html',
  styleUrls: ['./propertydetails.component.scss']
})
export class PropertydetailsComponent implements OnInit {

  public PropertyDetails : PropertyDetailsModel;
  public PropertyFinancial: PropertyFinancialsModel;

  public ptype : PropertyType;

  public a1:boolean = false;
  public a2:boolean = false;
  public a3:boolean = false;
  
  constructor(private data: DataService, private router: Router) { 
  }

  ngOnInit(): void {
    this.PropertyDetails = this.data.SelectedProperty.propertydetails;
    this.PropertyFinancial = this.data.SelectedProperty.propertyfinancials;
    this.ptype = this.data.PropertyTypes.find(x => x.PropertyTypeCode == this.data.SelectedProperty.propertydetails.propertytype);
    this.a1 = this.data.SelectedProperty.propertydetails.area1 > 0;
    this.a2 = this.data.SelectedProperty.propertydetails.area2 > 0;
    this.a3 = this.data.SelectedProperty.propertydetails.area3 > 0;
  }

  onSummarySheet(){
    this.router.navigate(['summarysheet'],{skipLocationChange:false});
  }
  onMapClicked(){
    this.router.navigate(['map'],{skipLocationChange:false});
  }

}
